import { render, staticRenderFns } from "./sport_event_start_reminder.vue?vue&type=template&id=257eea95&scoped=true&"
import script from "./sport_event_start_reminder.vue?vue&type=script&lang=js&"
export * from "./sport_event_start_reminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257eea95",
  null
  
)

export default component.exports